import React, { useState } from "react";

const PainelRetratil = ({ titulo, children, defaultOpen = true }) => {
  const [aberto, setAberto] = useState(defaultOpen);

  return (
    <div
      style={{
        // border: "1px solid #ccc",
        marginBottom: "12px",
        margin:'0px',
        padding:'0px',

      }}
    >
      <div
        onClick={() => setAberto(!aberto)}
        style={{
          padding: "10px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#034EA2",
          borderRadius: "8px 8px 0 0",
          marginBottom: aberto ? "0" : "5px",
        }}
      >
        <strong style={{ color: "#fff" }}>{titulo}</strong>
        <div style={{ fontSize: "8px"  ,color: "#ffffff" }}>{aberto ? "▲" : "▼"}</div>
      </div>

      {aberto && <div style={{ padding: "0px"}}>{children}</div>}
    </div>
  );
};

export default PainelRetratil;
